/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import SidebarIzquierda from './SidebarIzquierda';
import ModalFotoPerfil from '../usuario/ModalFotoPerfil';

  
import * as validations from '../../validations/validations';

import { Segment} from 'semantic-ui-react'; 
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment'; 
import $ from 'jquery';
 import * as userActions from '../../actions/userActions';
import * as usuarioActions from '../../actions/usuarioActions';


class ManageSidebarIzquierda extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            showModalPerfil:false,
            strings:[],
            permisos:{},
			tag:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        
        
		
    }
    
     closeModalPerfil=()=>{
         this.setState({"showModalPerfil":false})
     }


     onShowModalPerfil=()=>{
         this.setState({"showModalPerfil":true})
     }
     
     cambiarFoto=(event)=>{
        event.preventDefault();
      
        
         var adjunto=this.state.adjunto;
        
        if(adjunto instanceof File){
        var form_data = new FormData();
        form_data.append('file', adjunto);            
        //let adjuntoUI={"login":this.props.usuarioActual.login};
        //form_data.append('login',JSON.stringify(adjuntoUI));
            
            
            this.props.usuarioActions.saveAdjunto(form_data, this.props.user).then(() => {
                toastr.success("Archivo guardado!!!."); 
                 
                
                this.setState({"adjunto": ""});
               this.setState({"showModalPerfil":false})
            }).catch(error=>{
              toastr.error(error.responseJSON.message);
            });
        }else{
            
            toastr.error("Debes seleccionar una foto de perfil");
        }
    }
   
 
    onChangeAdjuntar=(event, data)=> {	
        let datos = this.state.datosAdjunto;
        let field= data.name;		
        let value=	data.value;		
  
        if(data.type == 'file'){
             
            let file = event.target.files[0];
            if (!file){
                return;
            }
           
            
            var Extension = event.target.files[0].name.substring(
                    event.target.files[0].name.lastIndexOf('.') + 1).toLowerCase();

            if (!(Extension == "png" || Extension == "bmp"
                    || Extension == "jpeg" || Extension == "jpg")) {
                
                toastr.error("Solo se permiten imagenes de tipo jpeg, png, jpg y bmp!!!");
                return;
            }
         
            if(event.target.files[0].size<=2097152){
                
                this.setState({"adjunto": event.target.files[0]});    
        
            }else{
                
                toastr.error("No se permiten imagenes mayores a 2 Mb!!!");
                return;
            } 

        }
    }


     
     
     componentWillReceiveProps(nextProps) {	
	  this.setState({
		  "fotoPerfil": nextProps.fotoPerfil		  
	  });
	}
     
     
    cerrarSesion=(signOut)=>{
        this.props.userActions.addUser(null);
         signOut();
    }
       
    render() {	
          
       return (
              <Segment  style={{minHeight: "93vh"}}>
                <SidebarIzquierda 
           
                    cerrarSesion={this.cerrarSesion}
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.tag}
                    onSave={this.onSave}     
                    onShowModalPerfil={this.onShowModalPerfil}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    fotoPerfil={this.props.fotoPerfil}
                />
           
           <ModalFotoPerfil
                cambiarFoto={this.cambiarFoto}
                showModal={this.state.showModalPerfil}
                closeModal={this.closeModalPerfil}
                onSave={this.cambiarFoto}
                titulo={"Profile Image"}
                onChange={this.onChangeAdjuntar}
                strings={[]}
            />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
   
    return {    
        
        user:state.user,
        fotoPerfil:state.fotoPerfil,
        ajaxCallInProgress:state.ajaxCallInProgress
          
    }

}

function mapDispatchToProps(dispatch){

	return {   
        userActions: bindActionCreators(userActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch),
        
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageSidebarIzquierda);